import { render, staticRenderFns } from "./UserPostDetail.vue?vue&type=template&id=f1e536c2"
import script from "./UserPostDetail.vue?vue&type=script&lang=js"
export * from "./UserPostDetail.vue?vue&type=script&lang=js"
import style0 from "./UserPostDetail.vue?vue&type=style&index=0&id=f1e536c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports